import { render, staticRenderFns } from "./FullscreenHeaderDefault.vue?vue&type=template&id=0d0b950c&"
import script from "./FullscreenHeaderDefault.vue?vue&type=script&lang=js&"
export * from "./FullscreenHeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenHeaderDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports